export const SITE_CONFIG = {
  name: "Netsys Panamá",
  url: "https://netsyspanama.net",
  // TODO: pegar la URL real de Calendly (o definir REACT_APP_CALENDLY_URL en frontend/.env)
  calendlyUrl: process.env.REACT_APP_CALENDLY_URL || "",
  // TODO: datos de contacto reales (placeholders identificables)
  email: "info@netsyspanama.net",
  phone: "+507 6670-5720",
  // Enlace personalizado de soporte remoto (RustDesk)
  supportUrl: "https://github.com/rustdesk/rustdesk/releases/download/1.4.9/rustdesk-1.4.9-x86_64.exe",
  location: "Ciudad de Panamá, Panamá",
};

// Si REACT_APP_BACKEND_URL está definida (preview/Emergent), se usa esa;
// si no (auto-hospedaje), las llamadas van al mismo dominio (mismo origen).
const BACKEND_BASE = process.env.REACT_APP_BACKEND_URL || "";
export const API_URL = `${BACKEND_BASE}/api`;
